import PropTypes from 'prop-types'
import React from 'react'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="logo">
      <span className="icon fa-caret-up"></span>
    </div>
    <div className="content">
      <div className="inner">
        <h1>Ellissen Consulting Gmbh</h1>
        <p>
        <b>Risks</b> and <b>Opportunities</b> go digital.
        </p>
        <p>
        develop - implement - Enjoy
        </p>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('service')
            }}
          >
            Service
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('contact')
            }}
          >
            Contact
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('privacy')
            }}
          >
            privacy
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('notice')
            }}
          >
            Legal Notice
          </button>
        </li>
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
